import { z } from 'zod'

export const ADMINUSERMUTATIONSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminUserMutationsPostResponseSchema = z.unknown()
export type AdminUserMutationsPostResponse = z.infer<typeof adminUserMutationsPostResponseSchema>
